<template>
  
</template>

<script>
export default {
    name: 'Centers',
    data(){
        return{ intended_url:this.$route.query.surl  }
    },
    mounted(){
        this.web_hits()
        window.location = atob(this.intended_url);
    }

};
</script>
